module.exports = __webpack_public_path__ + "img/img32.f43ed261.svg";